module.exports = __webpack_public_path__ + "static/media/stripe-payment.422c0e14.png";